import ContactBulkOperationsAPI from 'dashboard/api/contactBulkOperations';

export const submitContactBulkRequest = async ({
  accountId,
  userId,
  payload,
  isCurrent = () => true,
}) => {
  if (!accountId || !userId) throw new Error('Missing request owner');
  const operation = {
    ids: [...new Set(payload.ids.map(Number))].sort((a, b) => a - b),
    ...(payload.action_name ? { action_name: payload.action_name } : {}),
    ...(payload.labels
      ? {
          labels: Object.fromEntries(
            Object.keys(payload.labels)
              .sort()
              .map(key => [key, [...new Set(payload.labels[key])].sort()])
          ),
        }
      : {}),
  };
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(JSON.stringify(operation))
  );
  const signature = Array.from(new Uint8Array(digest), byte =>
    byte.toString(16).padStart(2, '0')
  ).join('');
  const storageKey = `contact-bulk-request:${accountId}:${userId}:${signature}`;
  if (!isCurrent()) throw new Error('Request owner changed');
  const requestKey = sessionStorage.getItem(storageKey) || crypto.randomUUID();
  // Persist before sending. A storage failure must not create an untracked request.
  sessionStorage.setItem(storageKey, requestKey);
  const response = await ContactBulkOperationsAPI.create({
    ...operation,
    request_key: requestKey,
  });
  sessionStorage.removeItem(storageKey);
  return response;
};
